<div class="fluid-container">
  <h2 class="card-header card-header-forheader ">
    Patient
    Call Center Reservation</h2>
  <!-- Existing Patient Or Client #21-2-2024-->
  <div class="row">
    <div class="col-2" *ngIf="showNewPatientArea==false">
      <sanabel-selectize appcode="1023" [(ngModel)]="patCode" name="patient" (clicked)="patientClicked($event)">
      </sanabel-selectize>
    </div>

    <div class="col-2" *ngIf="showNewPatientArea==false">
      <sanabel-selectize appcode="1162" [(ngModel)]="cCCallBeneficiarySerial" name="client"
        (clicked)="clientClicked($event)">
      </sanabel-selectize>
    </div>
    <div class="col-2">
      <sanabel-selectize appcode="1298" [(ngModel)]="branchId" name="client" (clicked)="branchClicked($event)">
      </sanabel-selectize>
    </div>

    <div class="col-2">
      <div class="form-group">
        <div>
          <sanabel-selectize [SearchKeys]="{levelNo:3,callCenterFlag:1}" [(ngModel)]="serviceCode" #serviceSelectize
            appcode="1082" (clicked)="onServicsClicked($event)">
          </sanabel-selectize>
        </div>

      </div>
    </div>
    <div class="col-2" style="margin: 30px;">
      <button type="button" class="btn btn-success 
      fa-pull-right fs-it-btn" *ngIf="showNewPatientArea==false" (click)="addNewPat()">
        <i class="fa fa-plus fa-custom" aria-hidden="true"></i>
        <span class="fs-it-btn-vertical-line"></span>
        {{
        translate.currentLang == "ar"
        ? "اضافة مريض جديد"
        : "Add New Patient"
        }}
      </button>
      <button type="button" class="btn btn-danger fa-pull-right fs-it-btn" *ngIf="showNewPatientArea==true"
        (click)="cancelAddNewPat()">
        <i class="fa fa-times fa-custom" aria-hidden="true"></i>
        <span class="fs-it-btn-vertical-line"></span>
        {{
        translate.currentLang == "ar"
        ?"الغاء اضافة مريض جديد"
        : "Cancel Adding New Patient"

        }}
      </button>
    </div>
    <div class="col-sm-2" style="margin-top: 33px;"
      *ngIf="this.cCCallBeneficiarySerial>0 || this.patCode>0 || showNewPatientArea==true">
      <input type="checkbox" name="sendMessageFlag" [(ngModel)]="sendMessageFlag">Send sms Message
    </div>
    <div class="col-sm-3" style="margin-top: 33px;" *ngIf="showNewPatientArea==true">
      <div class="form-check form-check-inline">
        <input class="form-check-input" type="radio" id="inlineRadio1" name="reservationType"
          [(ngModel)]="reservationType" [value]="1" />
        <strong class="form-check-label radCheck" for="inlineRadio1">
          {{translate.currentLang=='ar'?'حجز كمريض ثابت':'Book As Patient'}}

        </strong>
      </div>
      <div class="form-check form-check-inline">
        <input class="form-check-input" type="radio" id="inlineRadio2" name="reservationType"
          [(ngModel)]="reservationType" [value]="2" />
        <strong class="form-check-label radCheck" for="inlineRadio2">
          {{translate.currentLang=='ar'?'حجز كعميل':'Book As Client '}}
        </strong>
      </div>
    </div>
  </div>

  <!-- New Patient -->
  <div *ngIf="showNewPatientArea==true">

    <form class="card-header border" [formGroup]="patReservationForm" novalidate>
      <div class="row">
        <name-component #name [namingTranslationSetting]="5" [nameAllowNumber]="true"></name-component>
      </div>
      <!-- kareem -->
      <!-- <div class="col-3">
          <label for="birthDate">
            {{ "BIRTHDATE" | translate }}
          </label>
          <div class="input-group input-group-sm">
            <input class="form-control form-control-sm" [tabindex]="6" placeholder="{{ 'DATEFORMAT' | translate }}"
              formControlName="birthDateNgb" ngbDatepicker tabindex="-1" #birthDate="ngbDatepicker"
              [minDate]="{ year: 1900, month: 1, day: 1 }" />
            <div class="input-group-addon" (click)="birthDate.toggle()">
              <i class="fa fa-calendar"></i>
            </div>
          </div>
        </div> -->
      <div class="row">
        <div class="col-4" style="display: flex; justify-content: space-between;">
          <div class="row">
            <div class="col-2">
              <label>
                {{'YEAR' | translate}}
              </label>
              <input type="number" class="form-control" formControlName="ageInYear" autofocus #approxAgeYear
                (change)="clacBirthDateFromAge(approxAgeYear.value , approxAgeMonth.value ,approxAgeDays.value)">
            </div>
            <div class="col-2">
              <label>
                {{'MONTH' | translate}}
              </label>
              <input type="number" class="form-control" formControlName="ageInMonth" autofocus #approxAgeMonth
                (change)="clacBirthDateFromAge(approxAgeYear.value , approxAgeMonth.value ,approxAgeDays.value)">
            </div>
            <div class="col-2">
              <label>
                {{'DAY' | translate}}
              </label>
              <input type="number" class="form-control" formControlName="ageInDays" autofocus #approxAgeDays
                (change)="clacBirthDateFromAge(approxAgeYear.value , approxAgeMonth.value ,approxAgeDays.value)">
            </div>
            <div class="col-6">
              <label for="birthDate">
                {{'BIRTHDATE' | translate}}
              </label>
              <div class="input-group input-group-sm">
                <input class="form-control" placeholder="{{'DATEFORMAT' | translate}}" formControlName="birthDateNgb"
                  tabindex="13" ngbDatepicker #birthDate="ngbDatepicker" [minDate]="{'year':1900,'month':1,'day':1}"
                   (navigate)="getHigriDate();calcage($event)"
                  (change)=" getHigriDate();calcage($event)">
                <div class="input-group-addon" (click)="birthDate.toggle()">
                  <i class="fa fa-calendar"></i>
                </div>
              </div>
            </div>
          </div>

        </div>

        <div class="col-2">
          <sanabel-selectize appcode="1" [tabindex]="7" #selectizeGender [excludedCodes]="'3'" formControlName="gender">
          </sanabel-selectize>
        </div>

        <div class="col-sm-2">
          <div class="form-group">
            <sanabel-selectize appcode="1013" required="false" formControlName="nationalityId" [tabindex]="8">
            </sanabel-selectize>
          </div>
        </div>
        <div class="col-2">
          <div class="form-group">
            <label>{{ "MOBILENUMBER" | translate }}</label>
            <input class="form-control form-control-sm" tabindex="19" type="text" formControlName="mobile"
              (change)="onMobileKeyUp($event)" />
          </div>

          <div *ngIf="
       patReservationForm.controls['mobile'].errors &&
            (patReservationForm.controls['mobile'].dirty ||
            patReservationForm.controls['mobile'].touched)
          " class="alert alert-danger"><strong> الرقم غير صحيح </strong></div>
        </div>

        <div class="col-2">
          <div class="form-group">
            <label>{{ "FAMILYMOBILENUMBER" | translate }}</label>
            <input class="form-control form-control-sm" tabindex="20" type="text" formControlName="familyMobile" />
          </div>

          <div *ngIf="
       patReservationForm.controls['familyMobile'].errors &&
            (patReservationForm.controls['familyMobile'].dirty ||
            patReservationForm.controls['familyMobile'].touched)
          " class="alert alert-danger"><strong> الرقم غير صحيح </strong></div>
        </div>
        <div class="col-2">
          <label class="small">{{'HOWTOREACHUS' | translate}}</label>
          <sanabel-selectize appcode="315" [tabindex]="21" formControlName="howToReachUs" [simpleView]="true">
          </sanabel-selectize>

        </div>




      </div>

    </form>

  </div>
  <div class="row" *ngIf="patCode >0 || cCCallBeneficiarySerial>0 || showNewPatientArea==true">
    <div class="col text-center">
      <button type="button" class="btn btn-primary  fs-it-btn" (click)="savePatientReservation()">
        <i class="fa fa fa-floppy-o fa-custom" aria-hidden="true"></i>
        <span class="fs-it-btn-vertical-line"></span>
        {{
        translate.currentLang == "ar"
        ? "حفظ "
        : "Save"
        }}
      </button>
    </div>
  </div>
</div>
<div>
  <block-modal-container #popup >
    <ng-container class="modal-title">
    </ng-container>
    <ng-container class="modal-body" [ngComponentOutlet]="dynamicComponent"></ng-container>
  </block-modal-container>
</div>